import { apiGet } from './client';
import type { OperationResult } from './types';

// ─────────────────────────────────────────────────────────────────────────────
// System Health — drives the Platform → System Health page.
// One round-trip pings every dependency in parallel server-side and returns
// per-component status. The page polls this every ~30 seconds.
// ─────────────────────────────────────────────────────────────────────────────

export type HealthStatus = 'ok' | 'degraded' | 'down' | 'unknown';

export interface HealthCheck {
  component: string;
  status: HealthStatus;
  latencyMs: number;
  checkedAtUtc: string;
  detail?: string | null;
}

export interface HealthSummary {
  generatedAtUtc: string;
  overall: HealthStatus;
  components: HealthCheck[];
}

export async function getSystemHealth(): Promise<HealthSummary> {
  const wrapped = await apiGet<OperationResult<HealthSummary>>('/api/SystemHealth/Live');
  if (!wrapped.isSuccess || !wrapped.data) {
    throw new Error(wrapped.message || 'Failed to load system health');
  }
  return wrapped.data;
}
